import React from "react";
import * as CivicClerk from "./CivicClerk";
import * as CivicEngageCentral from "./CivicEngageCentral";
import * as CivicEngageEvolve from "./CivicEngageEvolve";
import * as CivicHR from "./CivicHR";
import * as CivicOptimize from "./CivicOptimize";
import * as CivicPlus from "./CivicPlus";
import * as CivicReady from "./CivicReady";
import * as CivicRec from "./CivicRec";
import * as CivicService from "./CivicService";
import * as SeeClickFix from "./SeeClickFix";
import * as Preamble from "./Preamble";
const logoComponents = {
  CivicClerk: {
    default: CivicClerk.default,
    white: CivicClerk.CivicClerkLogoWhite,
    circle: CivicClerk.CivicClerkLogoCircle
  },
  "CivicEngage Central": {
    default: CivicEngageCentral.default,
    white: CivicEngageCentral.CivicEngageCentralLogoWhite,
    circle: CivicEngageCentral.CivicEngageCentralLogoCircle
  },
  "CivicEngage Evolve": {
    default: CivicEngageEvolve.default,
    white: CivicEngageEvolve.CivicEngageEvolveLogoWhite,
    circle: CivicEngageEvolve.CivicEngageEvolveLogoCircle
  },
  CivicHR: {
    default: CivicHR.default,
    white: CivicHR.CivicHRLogoWhite,
    circle: CivicHR.CivicHRLogoCircle
  },
  CivicOptimize: {
    default: CivicOptimize.default,
    white: CivicOptimize.CivicOptimizeLogoWhite,
    circle: CivicOptimize.CivicOptimizeLogoCircle
  },
  CivicPlus: {
    default: CivicPlus.default,
    white: CivicPlus.CivicPlusLogoWhite,
    circle: CivicPlus.CivicPlusLogoCircle
  },
  CivicReady: {
    default: CivicReady.default,
    white: CivicReady.CivicReadyLogoWhite,
    circle: CivicReady.CivicReadyLogoCircle
  },
  CivicRec: {
    default: CivicRec.default,
    white: CivicRec.CivicRecLogoWhite,
    circle: CivicRec.CivicRecLogoCircle
  },
  CivicService: {
    default: CivicService.default,
    white: CivicService.CivicServiceLogoWhite,
    circle: CivicService.CivicServiceLogoWhite
  },
  SeeClickFix: {
    default: SeeClickFix.default,
    white: SeeClickFix.SeeClickFixLogoWhite,
    circle: SeeClickFix.SeeClickFixLogoCircle
  },
  Preamble: {
    default: Preamble.default,
    white: Preamble.PreambleLogoWhite,
    circle: Preamble.PreambleLogoWhite
  }
};
export const Logo = props => {
  const {
    product = "CivicPlus",
    white,
    circle,
    ...otherProps
  } = {
    role: "img",
    width: "100%",
    height: "100%",
    ...props
  };
  const productName = product in logoComponents ? product : "CivicPlus";
  const Component = white ? logoComponents[productName].white : circle ? logoComponents[productName].circle : logoComponents[productName].default;
  return /*#__PURE__*/React.createElement(Component, otherProps);
};
Logo.defaultProps = {
  role: "img",
  width: "100%",
  height: "100%"
};
export default Logo;